import { render } from "./IbayaqJenisBayaran.vue?vue&type=template&id=db96e26c"
import script from "./IbayaqJenisBayaran.vue?vue&type=script&lang=js"
export * from "./IbayaqJenisBayaran.vue?vue&type=script&lang=js"

import "./IbayaqJenisBayaran.vue?vue&type=style&index=0&id=db96e26c&lang=css"
import "./IbayaqJenisBayaran.vue?vue&type=style&index=1&id=db96e26c&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__